module.exports = __webpack_public_path__ + "img/2_3_2_2.eb701b2f.png";